import { useInfiniteQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { AgenciaTopFreelancer } from "@/hooks/useAgenciaTimeline";

// v_agencia_freelancer_relacao (sql/150) ainda não está no types.ts gerado -> cast.
const relacaoDb = supabase as unknown as {
  from: (table: string) => any; // eslint-disable-line @typescript-eslint/no-explicit-any
};

export const AGENCIA_FREELANCER_RELACAO_PAGE_SIZE = 20;

interface AgenciaFreelancerRelacaoPagina {
  linhas: AgenciaTopFreelancer[];
}

/**
 * Todos os freelancers que já se cruzaram com a agência (candidatura, projeto,
 * avaliação ou radar) — a aba "Freelancers" da página de detalhe. Consulta
 * direta à view golden (não ao top_freelancers da RPC de timeline, que é só o
 * top 10 usado na lane/resumo). Paginação server-side via .range() (páginas de
 * 20, "Mostrar mais" acumulando), mesmo padrão do useVagaColumn: página cheia
 * => provavelmente há mais, página parcial => acabou.
 */
export function useAgenciaFreelancerRelacao(agenciaId?: string | null) {
  return useInfiniteQuery({
    queryKey: ["agencia-freelancer-relacao", agenciaId],
    enabled: !!agenciaId,
    staleTime: 5 * 60 * 1000,
    initialPageParam: 0,
    queryFn: async ({ pageParam }): Promise<AgenciaFreelancerRelacaoPagina> => {
      const inicio = pageParam;
      const fim = inicio + AGENCIA_FREELANCER_RELACAO_PAGE_SIZE - 1;
      const { data, error } = await relacaoDb
        .from("v_agencia_freelancer_relacao")
        .select("*")
        .eq("agencia_id", agenciaId)
        .order("projetos_juntos", { ascending: false })
        .order("vezes_aprovado", { ascending: false })
        .range(inicio, fim);
      if (error) throw error;
      return { linhas: (data as AgenciaTopFreelancer[]) ?? [] };
    },
    getNextPageParam: (ultimaPagina, todasPaginas) => {
      if (ultimaPagina.linhas.length < AGENCIA_FREELANCER_RELACAO_PAGE_SIZE) return undefined;
      return todasPaginas.reduce((total, pagina) => total + pagina.linhas.length, 0);
    },
  });
}
